'use client';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const TabWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 0 ${Spacers.BASE}rem;
  gap: ${Spacers.BASE}rem;

  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }

  margin: 0 -${Spacers.BASE}rem;
`;